import { BaseService } from '../../../infra/base.service'
import type { Link } from './link'
import type { SitesLinksRepository } from './links.repository'

export class SitesLinksService extends BaseService<Link> {
    constructor(private rep: SitesLinksRepository) {
        super(rep)
    }
}
